import { render } from "./homeTrendsCentre.vue?vue&type=template&id=4ffad16b&scoped=true"
import script from "./homeTrendsCentre.vue?vue&type=script&lang=js"
export * from "./homeTrendsCentre.vue?vue&type=script&lang=js"

import "./homeTrendsCentre.vue?vue&type=style&index=0&id=4ffad16b&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffad16b"]])

export default __exports__